var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-company-box flex items-center justify-center"},[_c('img',{attrs:{"src":`${_vm.noSave ? _vm.logoString : _vm.getUserLogo}`,"alt":"Company Logo"},on:{"error":function($event){$event.target.src = '/e/favicon192x192.png'}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }